export enum RatingCreatorType {
    CLIENT = 'CLIENT'
}



// WEBPACK FOOTER //
// ./src/types/enums/RatingCreatorType.ts